/**
 * This file is to center wysiwyg button which is inline-block by wrapping it in a div and center aligning
 */

const buttons = Array.from(document.querySelectorAll('.js-wysiwyg-button'));

if (buttons.length) {
    buttons.forEach((btn) => {
        const container = document.createElement('div');
        container.classList.add('text-center', 'mt-15');
        btn.parentNode.insertBefore(container, btn);
        container.appendChild(btn);
    });
}
